import { render } from "./UserListView.vue?vue&type=template&id=88712a40"
import script from "./UserListView.vue?vue&type=script&lang=js"
export * from "./UserListView.vue?vue&type=script&lang=js"

import "./UserListView.vue?vue&type=style&index=0&id=88712a40&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__